module.exports = __webpack_public_path__ + "static/thumbnail-lyrics-63230f1013d80ac55ed6daf7014c4593.png";